
async function loadModules() {
  for (const module of window.modules) {
    if (module === 'behaviors_index') {
    executeModule(await import('../lib/behaviors/webpack-index.js'))
  }
  
if (module === 'page_2fa_configuration') {
    executeModule(await import('../lib/page/2fa/index.js'))
  }
  
if (module === 'page_accounts') {
    executeModule(await import('../lib/page/accounts/index.js'))
  }
  
if (module === 'page_activity_index') {
    executeModule(await import('../lib/page/activity/index.js'))
  }
  
if (module === 'page_add_on_management') {
    executeModule(await import('../lib/page/manage-add-ons/index.js'))
  }
  
if (module === 'page_android_notification_channels_detail') {
    executeModule(await import('../lib/page/android-notification-channels/detail.js'))
  }
  
if (module === 'page_api-keys') {
    executeModule(await import('../lib/page/api-integrations/index.js'))
  }
  
if (module === 'page_app_config') {
    executeModule(await import('../lib/page/app_config.js'))
  }
  
if (module === 'page_app_content_templates') {
    executeModule(await import('../lib/page/content-templates/index.tsx'))
  }
  
if (module === 'page_app_experiment_report') {
    executeModule(await import('../lib/page/experiments/report.js'))
  }
  
if (module === 'page_app_list') {
    executeModule(await import('../lib/page/app_list/index.tsx'))
  }
  
if (module === 'page_app_messages') {
    executeModule(await import('../lib/page/app_messages/index.js'))
  }
  
if (module === 'page_app_message_search') {
    executeModule(await import('../lib/page/message-search/index.tsx'))
  }
  
if (module === 'page_app_service_settings') {
    executeModule(await import('../lib/page/app-service-settings/index.js'))
  }
  
if (module === 'page_app_stats') {
    executeModule(await import('../lib/page/app-stats/index.ts'))
  }
  
if (module === 'page_app_web_migration') {
    executeModule(await import('../lib/page/app-web-migration/index.tsx'))
  }
  
if (module === 'page_apple_news') {
    executeModule(await import('../lib/page/apple-news/index.js'))
  }
  
if (module === 'page_apple_news_composer') {
    executeModule(await import('../lib/page/apple-news/composer.js'))
  }
  
if (module === 'page_auto_upgrade_management') {
    executeModule(await import('../lib/page/auto-upgrade-management/index.js'))
  }
  
if (module === 'page_app_audience_attributes') {
    executeModule(await import('../lib/page/audience/attributes/index.tsx'))
  }
  
if (module === 'page_brochure') {
    executeModule(await import('../lib/page/brochures/index.js'))
  }
  
if (module === 'page_checkout') {
    executeModule(await import('../lib/page/checkout/index.js'))
  }
  
if (module === 'page_company_whitelist_editor') {
    executeModule(await import('../lib/page/company_whitelist_editor.js'))
  }
  
if (module === 'page_connect') {
    executeModule(await import('../lib/page/connect/index.js'))
  }
  
if (module === 'page_control_panel') {
    executeModule(await import('../lib/page/control_panel/index.ts'))
  }
  
if (module === 'page_control_panel_accengage') {
    executeModule(await import('../lib/page/control_panel/accengage/index.tsx'))
  }
  
if (module === 'page_control_panel_company') {
    executeModule(await import('../lib/page/control_panel/company/index.js'))
  }
  
if (module === 'page_control_panel_company_csvs') {
    executeModule(await import('../lib/page/control_panel/company/csvs.ts'))
  }
  
if (module === 'page_control_panel_composer_templates') {
    executeModule(await import('../lib/page/control_panel/composer_templates.js'))
  }
  
if (module === 'page_control_panel_configs-records') {
    executeModule(await import('../lib/page/control_panel/configs-records/index.ts'))
  }
  
if (module === 'page_control_panel_connect') {
    executeModule(await import('../lib/page/control_panel/company/connect.ts'))
  }
  
if (module === 'page_control_panel_email') {
    executeModule(await import('../lib/page/control_panel/email/index.ts'))
  }
  
if (module === 'page_control_panel_app-email') {
    executeModule(await import('../lib/page/control_panel/app-email/index.ts'))
  }
  
if (module === 'page_control_panel_app_sms') {
    executeModule(await import('../lib/page/control_panel/app-sms/index.ts'))
  }
  
if (module === 'page_control_panel_health-check') {
    executeModule(await import('../lib/page/control_panel/company/health-check.ts'))
  }
  
if (module === 'page_control_panel_insight') {
    executeModule(await import('../lib/page/control_panel/insight/index.js'))
  }
  
if (module === 'page_control_panel_change-history') {
    executeModule(await import('../lib/page/control_panel/change-history/index.ts'))
  }
  
if (module === 'page_control_panel_predictive_features') {
    executeModule(await import('../lib/page/control_panel/predictive_audiences/index.ts'))
  }
  
if (module === 'page_control_panel_push') {
    executeModule(await import('../lib/page/control_panel/push.js'))
  }
  
if (module === 'page_control_panel_search') {
    executeModule(await import('../lib/page/control_panel/search/search-page.ts'))
  }
  
if (module === 'page_control_panel_sentry-test') {
    executeModule(await import('../lib/page/control_panel/sentry-test.js'))
  }
  
if (module === 'page_control_panel_template') {
    executeModule(await import('../lib/page/control_panel/template.js'))
  }
  
if (module === 'page_control_panel_templates') {
    executeModule(await import('../lib/page/control_panel/templates.ts'))
  }
  
if (module === 'page_control_panel_usage') {
    executeModule(await import('../lib/page/control_panel/company/usage.js'))
  }
  
if (module === 'page_control_panel_user_apps') {
    executeModule(await import('../lib/page/control_panel/user-apps/index.ts'))
  }
  
if (module === 'page_control_panel_employee-user-audit') {
    executeModule(await import('../lib/page/control_panel/employee-user-audit/index.ts'))
  }
  
if (module === 'page_dashboard') {
    executeModule(await import('../lib/page/dashboard.js'))
  }
  
if (module === 'page_device_lookup') {
    executeModule(await import('../lib/page/device-lookup/index.js'))
  }
  
if (module === 'page_deep_links_detail') {
    executeModule(await import('../lib/page/deep_links/detail.js'))
  }
  
if (module === 'page_demo_app_invite') {
    executeModule(await import('../lib/page/demo-app-invite/index.js'))
  }
  
if (module === 'page_demo_app_invite_add_app') {
    executeModule(await import('../lib/page/demo-app-invite/add_app.js'))
  }
  
if (module === 'page_email_editor') {
    executeModule(await import('../lib/page/email-editor/index.js'))
  }
  
if (module === 'page_feeds') {
    executeModule(await import('../lib/page/feeds.js'))
  }
  
if (module === 'page_goatzart') {
    executeModule(await import('../lib/page/goatzart/index.js'))
  }
  
if (module === 'page_favorites') {
    executeModule(await import('../lib/page/favorites/index.ts'))
  }
  
if (module === 'page_app_settings') {
    executeModule(await import('../lib/page/app-settings/index.tsx'))
  }
  
if (module === 'page_insight_dashboards') {
    executeModule(await import('../lib/page/insight/dashboards.js'))
  }
  
if (module === 'page_insight_onboarding') {
    executeModule(await import('../lib/page/insight/onboarding.js'))
  }
  
if (module === 'page_lists_edit') {
    executeModule(await import('../lib/page/static-lists/edit.js'))
  }
  
if (module === 'page_lists_list') {
    executeModule(await import('../lib/page/static-lists/list.js'))
  }
  
if (module === 'page_login') {
    executeModule(await import('../lib/page/login.js'))
  }
  
if (module === 'page_onboarding') {
    executeModule(await import('../lib/page/onboarding/index.js'))
  }
  
if (module === 'page_orchestration_strategies') {
    executeModule(await import('../lib/page/orchestration_strategies/index.tsx'))
  }
  
if (module === 'page_push_templates') {
    executeModule(await import('../lib/page/push-templates/index.js'))
  }
  
if (module === 'page_push_templates_create') {
    executeModule(await import('../lib/page/push-templates/create.js'))
  }
  
if (module === 'page_reach-cert-management') {
    executeModule(await import('../lib/page/reach/cert-management/index.js'))
  }
  
if (module === 'page_reach-control-panel-template') {
    executeModule(await import('../lib/page/control_panel/reach-template.js'))
  }
  
if (module === 'page_reach-projects-dashboard') {
    executeModule(await import('../lib/page/reach/projects/project_dashboard.js'))
  }
  
if (module === 'page_reach-projects-index') {
    executeModule(await import('../lib/page/reach/projects/index.js'))
  }
  
if (module === 'page_reach-projects-new') {
    executeModule(await import('../lib/page/reach/projects/create_project.js'))
  }
  
if (module === 'page_reach-segment-editor') {
    executeModule(await import('../lib/page/reach/segment-editor/index.js'))
  }
  
if (module === 'page_reach-segments-list') {
    executeModule(await import('../lib/page/reach/segments-list/index.js'))
  }
  
if (module === 'page_reach-template-editor') {
    executeModule(await import('../lib/page/reach/template-editor/index.ts'))
  }
  
if (module === 'page_reach_beta-settings_my-teams') {
    executeModule(await import('../lib/page/reach/beta-settings/my-teams.js'))
  }
  
if (module === 'page_reach_beta-settings_team-management') {
    executeModule(await import('../lib/page/reach/beta-settings/team-management.js'))
  }
  
if (module === 'page_reach_team-access') {
    executeModule(await import('../lib/page/reach/team-access/index.js'))
  }
  
if (module === 'page_registration') {
    executeModule(await import('../lib/page/registration/index.js'))
  }
  
if (module === 'page_registration_setup-password') {
    executeModule(await import('../lib/page/registration/setup-password.js'))
  }
  
if (module === 'page_reports_app_opens') {
    executeModule(await import('../lib/page/reports_app_opens.js'))
  }
  
if (module === 'page_reports_audience_index') {
    executeModule(await import('../lib/page/reports_audience/index.js'))
  }
  
if (module === 'page_reports_custom_events') {
    executeModule(await import('../lib/page/reports/custom_events/index.js'))
  }
  
if (module === 'page_reports_emails_index') {
    executeModule(await import('../lib/page/reports/emails/index.js'))
  }
  
if (module === 'page_reports_sms_index') {
    executeModule(await import('../lib/page/reports/sms/index.ts'))
  }
  
if (module === 'page_reports_web_push') {
    executeModule(await import('../lib/page/reports/web_push/index.ts'))
  }
  
if (module === 'page_reports_hardsoft') {
    executeModule(await import('../lib/page/reports_hardsoft.js'))
  }
  
if (module === 'page_reports_omni-detail') {
    executeModule(await import('../lib/page/reports/omni-detail/index.js'))
  }
  
if (module === 'page_reports_opt_in') {
    executeModule(await import('../lib/page/reports_opt_in.js'))
  }
  
if (module === 'page_reports_pushes_sent') {
    executeModule(await import('../lib/page/reports_pushes_sent.js'))
  }
  
if (module === 'page_reports_time_in_app') {
    executeModule(await import('../lib/page/reports_time_in_app.js'))
  }
  
if (module === 'page_review_add_on') {
    executeModule(await import('../lib/page/manage-add-ons/review.js'))
  }
  
if (module === 'page_rich_composer') {
    executeModule(await import('../lib/page/goatzart/richpush-editor.js'))
  }
  
if (module === 'page_richpush-rpc') {
    executeModule(await import('../lib/page/richpush-rpc.js'))
  }
  
if (module === 'page_localized_rich_composer') {
    executeModule(await import('../lib/page/scrooge/localized.tsx'))
  }
  
if (module === 'page_segments_edit') {
    executeModule(await import('../lib/page/segments/edit.js'))
  }
  
if (module === 'page_segments_list') {
    executeModule(await import('../lib/page/segments/list.js'))
  }
  
if (module === 'page_segments_preview') {
    executeModule(await import('../lib/page/segments/preview.js'))
  }
  
if (module === 'page_sentry_feedback_form') {
    executeModule(await import('../lib/page/sentry-feedback-form.js'))
  }
  
if (module === 'page_series') {
    executeModule(await import('../lib/page/zita/series-configure.tsx'))
  }
  
if (module === 'page_series_builder') {
    executeModule(await import('../lib/page/zita/series-builder.tsx'))
  }
  
if (module === 'page_team_access') {
    executeModule(await import('../lib/page/team-access/index.tsx'))
  }
  
if (module === 'page_team_management') {
    executeModule(await import('../lib/page/team-management/index.js'))
  }
  
if (module === 'page_test_devices') {
    executeModule(await import('../lib/page/test-devices/index.js'))
  }
  
if (module === 'page_test_users') {
    executeModule(await import('../lib/page/test-users/index.js'))
  }
  
if (module === 'page_test_push') {
    executeModule(await import('../lib/page/test_push.js'))
  }
  
if (module === 'page_zoltar') {
    executeModule(await import('../lib/page/zoltar/index.js'))
  }
  
if (module === 'prototype_example') {
    executeModule(await import('../lib/prototypes/example/index.ts'))
  }
  
if (module === 'prototype_orc302') {
    executeModule(await import('../lib/prototypes/orc302/index.tsx'))
  }
  
  }
}

function executeModule(m) {
  // check for es2015-style default export
  if (m.default) {
    m.default()
  } else {
    // otherwise execute the export directly
    m()
  }
}

loadModules()
  